export const css = {
	root: '_2SGbBvNX',
	up: 'sSWQQQZj',
	actions: '_2KNLrYKL',
	action: '_2YzKHwM-',
	down: '_3bhWPO8O',
	left: 'wf10uRal',
	right: '_3P_HmDca',
	open: 'wgiFqqeC',
	actionTransition: '_29Q_HwbI',
	' _key': 'apic-theme/dojo/speed-dial'
};

export default css;
